import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {CatalogHeaderComponent} from '@app/catalog/header/catalog-header.component';
import {CatalogCarouselCardComponent} from '@app/catalog/carousels/carousel-card/carousel-card.component';

@Component({
  selector: 'px-catalog',
  templateUrl: './catalog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, CatalogHeaderComponent, CatalogCarouselCardComponent]
})
export class CatalogComponent {
  public readonly carouselSelectors = CatalogSelectors.CatalogCarousels;

}
